// The backend accepts any file, so the picker and the drop check limit
// attachments to images a browser can show as a thumbnail.
export const ACCEPTED_ATTACHMENT_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
];

export const ACCEPTED_ATTACHMENT_TYPES_LABEL = 'PNG, JPEG, GIF and WebP images';

export const isAcceptedAttachmentFile = (file: File) =>
  ACCEPTED_ATTACHMENT_TYPES.includes(file.type);

export const MAX_COMMENT_ATTACHMENTS = 10;
